<template>
    <div :class="{ locked: level === 0 && lockedClass(selectedReferential) }">
        <div v-for="criteria in sortedChildren" :key="criteria.id + '-' + criteria.children_ids.length">
            <div class="criteria-container" :class="['criteria-level-' + level, { 'has-children': criteria.children_ids.length > 0 }]">
                <div class="criteria-row" @click="(e) => crunchChildren(e, criteria)">
                    <div class="criteria-info">
                        <!-- <div class="criteria-id">
                        <i :class="criteria.collapsed ? 'bi bi-chevron-up' : 'bi bi-chevron-down'"></i>
                    </div> -->
                        <div class="criteria-reference">{{ criteria.reference }}</div>
                        <h3 class="criteria-title">{{ criteria.title }}</h3>
                    </div>
                    <div class="criteria-actions">
                        <button @click.stop="addChild(criteria)" :disabled="isReferentialLocked(selectedReferential)" v-if="hasQuestionIn(criteria) && !isReferentialLocked(selectedReferential)" class="btn btn-icon" title="Ajouter une thématique"><i class="bi bi-plus"></i></button>
                        <button @click.stop="editCriteria(criteria)" :disabled="isReferentialLocked(selectedReferential)" v-if="!isReferentialLocked(selectedReferential)" class="btn btn-icon" title="Modifier"><i class="bi bi-pencil-fill"></i></button>
                        <button @click.stop="addQuestion(criteria)" :disabled="isReferentialLocked(selectedReferential)" v-if="hasQuestion(criteria) && !isReferentialLocked(selectedReferential)" class="btn btn-icon" title="Ajouter une question"><i class="bi bi-question-lg"></i></button>
                        <button @click.stop="confirmDeleteCriteria(criteria.id)" :disabled="isReferentialLocked(selectedReferential)" v-if="!isReferentialLocked(selectedReferential) && !hasQuestionOrChildren(criteria)" class="btn btn-icon btn-danger" title="Supprimer"><i class="bi bi-trash3-fill"></i></button>
                        <button @click.stop="confirmDeleteChildrenAndCriteria(criteria)" :disabled="isReferentialLocked(selectedReferential)" v-if="!isReferentialLocked(selectedReferential) && hasQuestionOrChildren(criteria)" class="btn btn-icon btn-danger" title="Supprimer critère + enfants"><i class="bi bi-trash3-fill"></i></button>
                    </div>
                </div>
                <!-- Nested children -->
                <div v-if="filterIsActive || !criteria.collapsed">
                    <div v-if="criteria.children_ids.length > 0" class="criteria-children">
                        <ReferentialTreeEditor 
                            v-bind:children="criteria" 
                            v-bind:level="level + 1"
                            :filter-is-active="filterIsActive"
                        />
                    </div>
                    <!-- Questions section -->
                    <ReferentialQuestionEditor 
                        v-bind:criteria_id="criteria.id" 
                        :filter-is-active="filterIsActive"
                        class="criteria-questions"
                    />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
// import draggable from 'vuedraggable'
import ReferentialQuestionEditor from './ReferentialQuestionEditor.vue'
import '../../assets/styles/base.css'

export default {
    name: "ReferentialTreeEditor",
    props: ['children', 'level', 'filterIsActive'],
    computed: {
        ...mapState("auth", []),
        ...mapState("referential", ["criteriaTree", "selectedReferential", "canEditList", "questionTree", "loading"]),
        ...mapGetters("referential", ["fetchCriteria", "fetchChildrenCriteria", "fetchQuestionCriteria", "isReferentialLocked", "getReferentialStatus", "lockedClass"]),
        sortedChildren() {
            const childrenIds = this.children?.children_ids || [];
            if (childrenIds.length === 0) {
                return [];
            }

            let children = this.criteriaTree.filter(criteria =>
                childrenIds.includes(criteria.id)
            );

            children.sort((a, b) => {
                if (a.order_number !== b.order_number && 
                    a.order_number > 0 && b.order_number > 0) {
                    return a.order_number - b.order_number;
                }
                return a.id - b.id;
            });

            if (this.filterIsActive) {
                return children.filter(criteria => this.hasMatchingDescendant(criteria));
            }

            return children;
        },
        questions() {
            return [...this.questionTree.filter(question => question.criteria_id === this.children?.id)]
        },
    },
    watch: {
        children: {
            // eslint-disable-next-line no-unused-vars
            handler(newVal) {
                //console.log("children updated:", newVal)
            },
        },
        questions: {
            // eslint-disable-next-line no-unused-vars
            handler(newVal) {
                //console.log("questionTree updated:", newVal)
            },
        },
    },
    components: {
        ReferentialQuestionEditor,
        // draggable,
    },
    methods: {
        confirmDeleteCriteria(id) {
            this.$store.commit("referential/returnConfirmationObjectMutation", { 
                id: id, 
                type: "delete-criteria",
                title: "Suppression",
                message: "Êtes-vous sûr de vouloir supprimer ce critère?"
            })
        },
        confirmDeleteChildrenAndCriteria(criteria){
            this.$store.commit("referential/returnConfirmationObjectMutation", { 
                id: criteria.id, 
                type: "delete-children-criteria",
                title: "Suppression du critère et enfants",
                message: "Êtes-vous sûr de vouloir supprimer ce critère?\nCette action engendre une suppression en cascade\nVeuillez entrer la référence du critère à supprimer",
                flag:criteria.reference,
            })
        },
        addChild(criteria) {
            this.$store.commit("referential/makeCriteriaActiveMutation", [])
            this.$store.commit("referential/callerSetMutation", criteria)
            this.toggleCriteriaModalOpen()
        },
        addQuestion(criteria) {
            /* this.$store.commit("referential/clearActiveQuestion"); */
            this.$store.commit("referential/makeQuestionActiveMutation", [])
            this.$store.commit("referential/callerSetMutation", criteria)
            this.$store.commit("referential/toggleQuestionModal", !this.canEditList.questionEditorOpen)
        },
        editCriteria(criteria) {
            this.$store.commit("referential/callerSetMutation", [])
            this.$store.commit("referential/makeCriteriaActiveMutation", criteria)
            this.toggleCriteriaModalOpen()
        },
        toggleCriteriaModalOpen() {
            if (this.selectedReferential > 0) {
                this.$store.commit("referential/toggleCriteriaModal", !this.canEditList.criteriaEditorOpen)
            } else {
                this.$store.commit("referential/toggleCriteriaModal", false)
            }
        },
        hasQuestion(criteria) {
            if(criteria.children_ids.length > 0) {
                return false
            }
            
            var result = this.fetchQuestionCriteria(criteria.id)
            return !result
        },
        hasQuestionIn(criteria) {
            var result = this.fetchQuestionCriteria(criteria.id)
            return !result
        },
        hasQuestionOrChildren(criteria) {
            if(criteria.children_ids.length > 0) {
                return true
            }
            var result = this.fetchQuestionCriteria(criteria.id)
            return result
        },
        crunchChildren(event, criteria) {
            ////console.log(`ACTION: Clic sur le critère ID ${criteria.id}. État 'collapsed' actuel : ${criteria.collapsed}`);
            /* if (!criteria) return; */
            if (event.target.closest('.criteria-row')) {
                this.$store.commit("referential/collapseCriteriaMutation", criteria.id);
            }
        },
        hasMatchingDescendant(criteria) {
            const directQuestions = this.fetchQuestionCriteria(criteria.id);
            if (directQuestions) {
                const questionsArray = Array.isArray(directQuestions) ? directQuestions : [directQuestions];
                const hasDirectMatch = questionsArray.some(q => {
                    const firstLimit = q.question_limits && q.question_limits['0'] && q.question_limits['0'].sign.length>0 && q.question_limits['0'].limit.length>0;
                    const secondLimit = q.question_values && q.question_values['0']&& q.question_values['0'].possible_text === "Black";
                    return firstLimit || secondLimit;
                });
                if (hasDirectMatch) return true; 
            }
            if (criteria.children_ids && criteria.children_ids.length > 0) {
                const childrenCriteria = this.fetchChildrenCriteria(criteria.children_ids);
                return childrenCriteria.some(child => this.hasMatchingDescendant(child));
            }
            return false;
        },
        
        collectParentIds(criteriaId, idSet) {
            let currentId = criteriaId;
            while (currentId) {
                idSet.add(currentId);
                const criteria = this.criteriaTree.find(c => c.id === currentId);
                currentId = criteria ? criteria.parent : null;
            }
        },
        referentialStatus(referentialId){
            if(!referentialId === this.getReferentialStatus(referentialId)) {
                return {"LOCKED": false, "OWNER": false, "READONLY": false, "EDITOR": false};
            }else {
                //console.log("isReferentialLocked => status information :", this.getReferentialStatus(referentialId))
                return this.getReferentialStatus(referentialId);
            }
        },
    }
};
</script>

<style scoped>

.criteria-tree {
    display: flex;
    flex-direction: column;
    gap: 15px;
}

.criteria-container {
    margin-bottom: 15px;
    border-radius: 8px;
    background-color: white;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
    transition: all 0.2s ease;
    max-width: 100%;
}

.criteria-container:hover {
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
}

.criteria-level-0 {
    border-left: 4px solid var(--primary-color);
}

.criteria-level-1 {
    border-left: 4px solid var(--left2-color);
    margin-left: 24px;
}

.criteria-level-2 {
    border-left: 4px solid var(--left3-color);
    margin-left: 48px;
}

.criteria-level-3 {
    border-left: 4px solid var(--left4-color);
    margin-left: 72px;
}

.criteria-row {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 2px 13px;
    border-bottom: 1px solid #f0f0f0; 
    word-break: break-word;
}

.criteria-info {
    display: flex;
    align-items: center;
    flex: 1;
    padding: 4px 6px;
    gap: 50px;
    max-width: stretch;
}

.locked {
    opacity: 0.55;
}

.locked .locked {
    opacity: 1; 
}

.criteria-reference {
    background: #f8f9fa;
    padding: 4px 8px;
    border-radius: 4px;
    font-size: 13px;
    font-weight: 600;
    margin-right: 12px;
    min-width: 40px;
    max-height: 35px;
    text-align: center;
    margin-right: 20px;
}

.criteria-title {
    font-size: 16px;
    margin-left: 50px;
    font-weight: 500;
    text-align: left;
}

.criteria-actions {
    display: flex;
    gap: 2px;
    margin: 2px 10px 2px 0;
    opacity: 0;
    pointer-events: none;
    transition: opacity 0.2s;
}

.btn {
    border: none;
    border-radius: 4px;
    padding: 6px 12px;
    cursor: pointer;
    transition: all 0.2s;
    font-weight: 500;
}

.btn-icon {
    width: 30px;
    height: 30px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 50%;
    background: #f8f9fa;
    font-size: 18px;
    padding: 0;
    background-color: var(--hover-bg);
    color: var(--text-color);
}

.criteria-row:hover .criteria-actions,
.criteria-actions:focus-within {
    opacity: 1;
    pointer-events: auto;
}

.btn-icon:hover {
    color: var(--primary-color);
}

.criteria-children {
    margin: 0;
    padding: 0;
}

/* grid */
.referential-header,
.referential-item,
.referential-filter{
    display: grid;
    grid-template-columns: 26% 32% 14% 17% 12%;
    width: 100%;
    align-items: center;
}
.referential-filter{
    grid-template-columns: 60% 40%;
}
 
.referential-item:has(.actions-col) {
    grid-template-columns: 26% 32% 65% 17% ;
}

.referential-header {
    grid-template-columns: 26% 32% 14% 17% 12%;
    background-color: #f9f9f9;
    font-weight: bold;
    padding: 12px 15px;
    border-top-left-radius: var(--border-radius);
    border-top-right-radius: var(--border-radius);
    border: 1px solid var(--border-color);
    border-bottom: 2px solid #636262;
    margin-bottom: 0;
    top: 0;
}

.referential-header > div {
    cursor: pointer;
    user-select: none;
    position: relative;
}

.referential-header > div:hover {
    color: var(--primary-color);
}

.referential-header > div i {
    margin-left: 5px;
}

.status-cols, .date-cols, .user-cols {
    display: grid;
    grid-template-columns: 33% 44% 23%;
    width: 100%;
}

/* column styles */
.id-col, .title-col, .description-col, .status-col, .status2-col, .date-col, .user-col, .actions-col {
    padding: 8px;
    overflow: hidden;
    text-overflow: ellipsis;
}

.id-col {
    text-align: center;
    font-weight: 500;
}

/* filter style */
.referential-filter {
    padding: 12px 15px;
    margin-bottom: 15px;
    background-color: #f8f9fa;
    border-radius: var(--border-radius);
    border: 1px solid var(--border-color);
}

.filter-input {
    width: 100%;
    padding: 8px 12px;
    border: 1px solid #ddd;
    border-radius: var(--border-radius);
    font-size: 14px;
    transition: border-color 0.2s;
}

.filter-input:focus {
    outline: none;
    border-color: var(--primary-color);
    box-shadow: 0 0 0 2px var(--primary-light);
}

.filter-select {
    padding: 8px 12px;
    border: 1px solid #ddd;
    border-radius: var(--border-radius);
    background-color: white;
    cursor: pointer;
    width: 100%;
}
</style>